import { apiClient } from './client';
import type {
  CelebrationParagraph,
  CreateCelebrationParagraphDto,
  UpdateCelebrationParagraphDto,
  ParagraphStatus
} from '@/types/tag.types';

export class CelebrationParagraphService {

  /**
   * Get all paragraphs for a celebration
   */
  async getParagraphs(celebrationId: number): Promise<CelebrationParagraph[]> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/paragraphs`);
    return response.data.data || [];
  }

  /**
   * Create or update a paragraph (upsert)
   */
  async upsertParagraph(celebrationId: number, data: CreateCelebrationParagraphDto): Promise<CelebrationParagraph> {
    const response = await apiClient.post(`/celebrations/${celebrationId}/paragraphs`, data);
    return response.data.data;
  }

  /**
   * Update a paragraph
   */
  async updateParagraph(celebrationId: number, paragraphId: number, data: UpdateCelebrationParagraphDto): Promise<CelebrationParagraph> {
    const response = await apiClient.put(`/celebrations/${celebrationId}/paragraphs/${paragraphId}`, data);
    return response.data.data;
  }

  /**
   * Delete a paragraph
   */
  async deleteParagraph(celebrationId: number, paragraphId: number): Promise<void> {
    await apiClient.delete(`/celebrations/${celebrationId}/paragraphs/${paragraphId}`);
  }

  /**
   * Check paragraph completion status
   */
  async getParagraphStatus(celebrationId: number): Promise<ParagraphStatus> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/paragraphs/status`);
    return response.data.data;
  }
}

export const celebrationParagraphService = new CelebrationParagraphService();
